import { useState } from "react";
import { MonthlyIncomeODv2 } from "../../../../../Constants/Constants";
import SelectBox from "../../../../UI/SelectBox";

const MonthlyIncome = ({
  trigger,
  validation,
  saveInputAns,
  backClick,
  clsName,
  removeFromPending,
}) => {
  const [error, setError] = useState(false);

  const handleClick = async (e) => {
    let incomeMonthly = await trigger("monthlyIncome");
    let errorFlag = 0;
    if (!incomeMonthly) {
      errorFlag = 1;
    }
    if (errorFlag === 0) {
      setError("");

      saveInputAns(e);
      removeFromPending("monthlyIncome");
    } else {
      setError("Please select your Monthly Income");
      return false;
    }
  };

  return (
    <div className={`qsSlider slidea13 ${clsName}`}>
      <h2 className="qs-title slide-up-now">
        When you took out your overdraft, what was your monthly income?
      </h2>
      <div className="my-4  forms-body slide-up-now">
        <SelectBox
          type=""
          className="form-control"
          name="monthlyIncome"
          OptionValue={MonthlyIncomeODv2}
          onChange={() => setError("")}
          myRef={validation({
            required: true,
          })}
        />
        {error && <span className="error_msg mt-1">{error}</span>}
      </div>
      <div className="row  mb-3  ">
        <div className="col-12">
          <button
            className="btn-comm2    w-100  next7"
            type="button"
            name="monthlyIncome"
            onClick={handleClick}
            data-quest-id={101}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default MonthlyIncome;
